// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-avatar[data-v-f3b305a8]{position:relative;display:inline-block}.profile-avatar .lock[data-v-f3b305a8]{position:absolute;bottom:10%;right:-6%}", ""]);
// Exports
module.exports = exports;
